// cart modules
import axios from 'axios';
import forEach from 'lodash/map';
import find from 'lodash/find';
const touristEntryPoint = 'tour';
import { MOBILE_URL } from '../../api/url'; // eslint-disable-line import/no-extraneous-dependencies, import/extensions
import _ from 'lodash';

export const desiredAddCartShape = {
  totalCount: 'total_count',
};

export const isUserAuthenticated = () => {
  if (getToken() === undefined || getToken() === null) {
    return false;
  } else {
    return true;
  }
};

export const getLocalCart = (callback = () => {}) => {
  let cartProductsList = JSON.parse(localStorage.getItem('cart')) || [];
  callback(cartProductsList);
};

export const setLocalCart = (
  cartProductsList = [],
  callback = () => {},
) => {
  localStorage.setItem('cart', JSON.stringify(cartProductsList));
  callback();
};

export const clearLocalCart = (callback = () => {}) => {
  const emptyCartList = [];
  setLocalCart(emptyCartList, callback);
};

export const getToken = () => {
  const token = localStorage.getItem('token');
  return token;
}

export const flyToElement = (flyer, flyingTo) => {
  var $func = $(this);
  var divider = 3;
  var flyerClone = $(flyer).clone();
  $(flyerClone).css({position: 'absolute', top: $(flyer).offset().top + "px", left: $(flyer).offset().left + "px", opacity: 1, 'z-index': 10000});
  $('body').append($(flyerClone));
  var gotoX = $(flyingTo).offset().left + ($(flyingTo).width() / 2) - ($(flyer).width())/2;
  var gotoY = $(flyingTo).offset().top + ($(flyingTo).height() / 2) - ($(flyer).height())/2;
  
  $(flyerClone).animate(
    {
      opacity: 1,
      left: gotoX,
      width: $(flyer).width(),
      height: $(flyer).height(),
      queue: false
    }, 
    {
      duration: 500,
      queue: false,
      complete: function() {
        $(flyingTo).fadeOut('fast', function () {
            $(flyingTo).fadeIn('fast', function () {
                $(flyerClone).fadeOut('fast', function () {
                    $(flyerClone).remove();
                });
            });
        });
      }
    });
  $(flyerClone).animate(
    {
      opacity: 1,
      top: gotoY,
      width: $(flyer).width(),
      height: $(flyer).height(),
    }, 
    {
      duration: 800,
      queue: false,
      complete: function() {
        $(flyingTo).fadeOut('fast', function () {
            $(flyingTo).fadeIn('fast', function () {
                $(flyerClone).fadeOut('fast', function () {
                    $(flyerClone).remove();
                });
            });
        });
      }
    });
}

// initial state
const state = {
  cartProductsList: [],
  itemCount: 0,
  isClearCartModuleOpen: false,
  subtotal: 0,
  width: 0,
  isAuthenticated: false,
  cart: {},
  isLoadingCart: false,
  necessaryCartItems: {},
  addToCartLoading: false,
  addToCartSuccessful: false,
  itemAdded: null,
  cartClicked: false,
  itemDeletedLoading: false,
  itemDeleted: false,
}

// actions
const actions = {
  async addCart(context, item) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'post',
      url: `${MOBILE_URL}/order-cart`,
      data: {
        Product_id: item.Product_id,
        Quantity: item.quantity || 1,
      },
      headers: {
        Authorization: `JWT ${token}`,
     },
    };
    context.commit('addToCartLoading');
    await axios(config)
    .then((response) => {
      context.commit('itemAdded', item);
      context.commit('updateItemCount', response.data);
      // context.commit('itemAdded', item);
      context.commit('addToCartSuccessful');
    }, (err) => {
      console.log("addCart error", err);
    })
  },

  async getCart(context) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'get',
      url: `${MOBILE_URL}/order-cart`,
      headers: {
        Authorization: `JWT ${token}`,
     },
    };
    await axios(config)
    .then((response) => {
    context.commit('updateCartProduct', response.data)
    }, (err) => {
    console.log("getCart", err);
    })
  },

  async updateItemQuantity(context, [productId, quantity]) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'put',
      url: `${MOBILE_URL}/order-cart`,
      data: {
        Product_id: productId,
        Quantity: quantity,
      },
      headers: {
        Authorization: `JWT ${token}`,
      },
    };
    await axios(config)
    .then((response) => {
      context.commit('updateItemCount', response.data)
    }, (err) => {
      console.log("updateItemQuantity", err);
    });
  },

  async deleteCartItem(context, productId) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'delete',
      url: `${MOBILE_URL}/order-cart`,
      data: {
        Product_id: productId,
      },
      headers: {
        Authorization: `JWT ${token}`,
      },
    };
    context.commit('deleteLoading');
    await axios(config)
    .then((response) => {
      context.commit('deleteSuccessful');
    }, (err) => {
      console.log("deleteItemCart", err);
    });
  },

async saveAndAdjustCart(context, cartItems) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'POST',
      url: `${MOBILE_URL}/cart/`,
      data: cartItems,
      headers: {
        Authorization: `JWT ${token}`,
      },
  };
  await axios(config)
  .then(response => {
    context.commit('getNecessaryCartItems', response.data)
    context.commit('checkout/calculateGrandTotal', response.data, { root: true })
  }, (err) => {
    console.log("err", err);
  })
  },
  addProductToLocalCart(context, data) {
    let product = data[0] || data;
    let event = data[1];
    const callback = (cart) => {
      const cartProductsList = cart || [];
      let itemCount = 0;
      if (cartProductsList) {
        const itemIfFound = find(cartProductsList, item => item.Product_id === product.Product_id);
        if (itemIfFound) {
          const productQuan = product.quantity ? product.quantity : 1;
          const numCanBePurchased = product.StockLevel - itemIfFound.quantity - productQuan;
          if(numCanBePurchased < 0) {
            alert(`Sorry, there are only ${product.StockLevel} available of ${product.Name}`);
            return;
          }
          itemIfFound.quantity += product.quantity || 1;
        } else {
          product.quantity = product.quantity || 1;
          cartProductsList.push(product);
          if (event) {
            flyToElement(event.target, $('.cart-link'));
          }
        }
      } else {
        cartProductsList.push(product);
        if (event) {
          flyToElement(event.target, $('.cart-link'));
        }
      }
      forEach(cartProductsList, (item) => {
        itemCount += item.quantity;
      });
      context.commit('updateCartFromLocal', [cartProductsList, itemCount])
      setLocalCart(cartProductsList);
    };
    getLocalCart(callback);
  },

updateLocalCart(context, product) {
  const callback = (cart) => {
    const cartProductsList = cart || [];
    let itemCount = 0;
    if (cartProductsList) {
      const itemIfFound = find(cartProductsList, item => item.Product_id === product.Product_id);
      if (itemIfFound) {
        itemIfFound.quantity = product.quantity;
      }
    }
    forEach(cartProductsList, (item) => {
      itemCount += parseInt(item.quantity);
    });
    // updateItemCount(itemCount);
    context.commit('updateCartFromLocal', [cartProductsList, itemCount])
    setLocalCart(cartProductsList);
  };
  getLocalCart(callback);
},


incrementLocalCart(context, values) {
  let product = values[0];
  let event = values[1];
  const callback = (cart) => {
    const cartProductsList = cart || [];
    let itemCount = 0;
    if (cartProductsList) {
      const itemIfFound = find(cartProductsList, item => item.Product_id === product.Product_id);
      if (itemIfFound) {
        let quantity = itemIfFound.quantity + 1;
        if (quantity > itemIfFound.StockLevel) {
          alert(`Sorry, there are only ${product.StockLevel} available of ${product.Name}`)
        } else {
          itemIfFound.quantity += 1;
          if (event) {
            flyToElement(event.target, $('.cart-link'));
          }
        }
      } else {
        product.quantity = 1;
        cartProductsList.push(product);
        if (event) {
          flyToElement(event.target, $('.cart-link'));
        }
      }
    } else {
      product.quantity = 1;
      cartProductsList.push(product);
      if (event) {
        flyToElement(event.target, $('.cart-link'));
      }
    }
    forEach(cartProductsList, (item) => {
      itemCount += parseInt(item.quantity);
    });
    context.commit('updateCartFromLocal', [cartProductsList, itemCount])
    setLocalCart(cartProductsList);
  };
  getLocalCart(callback);
},

deleteLocalCart(context) {
  const callback = (cart) => {
  };
    clearLocalCart(callback);
},


 fetchCartProducts(context) {
  let cartProductsList = JSON.parse(localStorage.getItem('cart')) || [];
  let itemCount = 0;
  cartProductsList.map((item) => {
    itemCount += parseInt(item.quantity);
  })
  context.commit('updateCartFromLocal', [cartProductsList, itemCount])
},

/*
*@dirtyProduct is a product object with fields
*  that are not formatted yet
*/
// addProductToCart(dirtyProduct) {
//   let product = (dirtyProduct.productId)
//     ? { ...dirtyProduct }
//     : cleanProductData(dirtyProduct);
//   if (getLanguage() !== 'en') {
//     product = cleanForLanguage(product);
//   }
//   return new Promise((resolve) => {
//     if (isUserAuthenticated()) {
//       const handleSuccess = (response) => {
//         dispatch(updateItemCount(response.totalCount));
//         resolve();
//       };
//       // should add product to cart
//       addCart({
//         productId: product.productId,
//         quantity: product.quantity || 1,
//       }, handleSuccess);
//     } else {
//       addProductToLocalCart(product);
//       resolve();
//       }
//     });
//   },
//   checkAuthentication(context) {
    
//   }
   addProductToCart(context, payload) {
     let item = payload.item;
    const token = localStorage.getItem('token');
    const config = {
      method: 'get',
      url: `${MOBILE_URL}/order-cart`,
      headers: {
        Authorization: `JWT ${token}`,
     },
    };
    context.commit('addToCartLoading');
    axios(config)
    .then(res => {
      const result = res.data.Sales_Order_Lines.filter(product => {
        return product.ProductNum === item.ProductNum
      });
      if(result[0]) {
        const numCanBePurchased = item.quantity ? item.quantity : 1;
        if((item.StockLevel - result[0].Quantity - numCanBePurchased) >= 0 ) {
          payload.success(payload)  
          context.commit('addToCartSuccessful', res.data.TotalCount);     
        }else {
          payload.fail(item);
        }
      }else {
          payload.success(payload)
          context.commit('addToCartSuccessful', res.data.TotalCount);     
      }
    }, (err) => {
      console.log("getCart", err);
    });
  }
}

// mutations
const mutations = {
  updateItemCount(state, payload) {
    state.itemCount = payload.TotalCount;
  },
  fetchCardProducts(state, payload) {
    state.cartProductsList = payload;
  },
  updateCartProduct(state, payload) {
    state.cartProductsList = payload;
    state.itemCount = payload.TotalCount;
  },
  addCartProduct(state, payload) {
    state.cartProductsList = payload;
  },
  updateCartFromLocal(state, payload) {
    state.cartProductsList = payload.cartProductsList || payload[0];
    state.itemCount = payload.itemCount || payload[1];
  },
  getNecessaryCartItems(state, payload) {
    state.necessaryCartItems = payload;
  },
  addToCartLoading(state, payload) {
    state.addToCartLoading = true;
    state.addToCartSuccessful = false;
  },
  addToCartSuccessful(state, payload) {
    state.addToCartLoading = false;
    state.addToCartSuccessful = true;
    state.itemCount = payload;
  },
  resetAddToCartSuccess(state, payload) {
    state.addToCartLoading = false;
    state.addToCartSuccessful = false;
  },
  itemAdded(state, payload) {
    state.itemAdded = payload;
  },
  openCart(state, payload) {
    state.cartClicked = true;
  },
  closeCart(state, payload) {
    state.cartClicked = false; 
  },
  deleteLoading(state, payload) {
    state.itemDeletedLoading = true;
    state.itemDeleted = false;
  },
  deleteSuccessful(state, payload) {
    state.itemDeletedLoading = false;
    state.itemDeleted = true;
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/cart.js